/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnableGachaRequest } from '../../models/enable-gacha-request';
import { EnableGachaResponse } from '../../models/enable-gacha-response';

export interface AdminServiceEnableGacha$Params {
      body: EnableGachaRequest
}

export function adminServiceEnableGacha(http: HttpClient, rootUrl: string, params: AdminServiceEnableGacha$Params, context?: HttpContext): Observable<StrictHttpResponse<EnableGachaResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceEnableGacha.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnableGachaResponse>;
    })
  );
}

adminServiceEnableGacha.PATH = '/api/v3/gateway/admin/gacha/enable';
